import React from "react";
import { Row, Col, Container, Spinner, Form } from "react-bootstrap";
import { useEffect, useState, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import AppExtensionsSDK from "@pipedrive/app-extensions-sdk";
import axios from "axios";

import SearchWindowResults from "../components/searchWindow/SearchWindowResults";

import { getUrl } from "../helpers/url";
import { fetchMappings } from "../store/slice/mappingSlice";

import { useDispatch, useSelector } from "react-redux";

import { setShowErrorModal } from "../store/slice/modalSlice";

import { CmsConstructor } from "../helpers/cmsConstructor";
import CmsEditAndSave from "../helpers/CmsEditAndSave";
import { useCmsHook } from "../helpers/cmsHook";

import {
  onSelectedCountry,
  onChangeRadioFilter,
  storeSearchWindowInput,
} from "../store/slice/searchWindowSlice";

export const labelForVatOption = {
  Australia: "Australian Business Number(ABN)",
  Denmark: "CVR Number",
  Norway: "Organisation Number",
  Switzerland: "Unique Identification Number(UID)",
  Finland: "Business ID(Y-tunnus)",
  UK: "Company Number",
};

function SearchWindow() {
  const dataSources = {
    Australia: "Australian Business Registry Services (ABRS)",
    UK: "Companies House",
    Sweden: "Bolagsverket",
    Switzerland: "Commercial Register",
    Finland: "Finnish Patent and Registration Office (PRH)",
    Norway: "Brønnøysund Register Centre",
    Denmark: "Det Centrale Virksomhedsregister (CVR)",
  };

  const { cmsInstance, setCmsInstance } = useCmsHook();

  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(false);
  const [planData, setPlanData] = useState({});
  const effectRan = useRef(false);
  // const [isRefresh, setIsRefresh] = useState(false);

  const countries = useSelector((state) => state.searchWindow.countries);
  const selectedCountry = useSelector(
    (state) => state.searchWindow.selectedCountry
  );
  const radioFilter = useSelector((state) => state.searchWindow.radioFilter);

  // This function is responsible for initializing pipedrive sdk while opening it from iframe
  const initalizePipedriveSDK = async (id) => {
    try {
      await new AppExtensionsSDK({ identifier: id }).initialize({
        size: { height: 280 },
      });
    } catch (error) {
      console.log(error);
      let message;
      if (error.response && error.response.data.message)
        message = error.response.data.message;
      else message = error.message;
      dispatch(setShowErrorModal({ message: message }));
    }
  };

  // This function is responsible getting plan name and searches left above the search bar
  const getPlanInfo = async () => {
    try {
      setLoading(true);
      const companyId = searchParams.get("companyId");
      let { data: planData } = await axios.post(
        getUrl("REACT_APP_FIND_CUSTOMER"),

        {
          companyId,
        }
      );
      setPlanData(planData);
      setLoading(false);
    } catch (error) {
      console.log(error);
      let message;
      if (error.response && error.response.data.message)
        message = error.response.data.message;
      else message = error.message;
      dispatch(setShowErrorModal({ message: message }));
    }
  };

  const storeSelectedCountry = (value) => {
    dispatch(onSelectedCountry(value));
  };

  useEffect(() => {
    // Prevented useEffect firing twice in development by using the below condition
    if (effectRan.current === false) {
      const id = searchParams.get("id");
      if (id) {
        initalizePipedriveSDK(id);
      }
      getPlanInfo();
      return () => {
        effectRan.current = true;
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const companyId = searchParams.get("companyId");
    if (companyId) {
      dispatch(fetchMappings(companyId));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (selectedCountry === "Sweden") {
      dispatch(onChangeRadioFilter("search by vat"));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedCountry]);

  useEffect(() => {
    const cmsInstance = async () => {
      const cmsObj = await CmsConstructor(dispatch);
      setCmsInstance(cmsObj);
    };
    cmsInstance();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <div className="search-window">
        <div className="d-flex flex-row justify-content-center">
          <CmsEditAndSave />
        </div>
        <Container>
          <Col xs={12}>
            <Row className="d-flex flex-row justify-content-center">
              <Col
                xs={12}
                md={10}
                className="search-window-colored-container my-md-5"
              >
                {loading || !cmsInstance ? (
                  <div className="d-flex flex-column justify-content-center align-items-center loading-container">
                    <div className="d-flex flex-row justify-content-center align-items-center">
                      <Spinner
                        animation="border"
                        variant="success"
                        role="status"
                      >
                        <span className="visually-hidden">Loading...</span>
                      </Spinner>
                    </div>
                  </div>
                ) : (
                  <div>
                    <div className="search-window-container">
                      {cmsInstance &&
                        cmsInstance.showRichText(
                          "cmsContent.searchWindow",
                          "search-window-content"
                        )}
                      <p style={{ marginBottom: "4px" }}>
                        <span className="data-source">Data source:</span>{" "}
                        <span className="search-window-para">
                          {dataSources[selectedCountry]}
                        </span>
                      </p>
                      <div className="search-window-plan mt-2 mb-3 mt-md-3">
                        <div>
                          <Form.Select
                            className="search-window-countries ms-auto"
                            onChange={(e) =>
                              storeSelectedCountry(e.target.value)
                            }
                            value={selectedCountry}
                          >
                            {countries.map((country, index) => (
                              <option key={index}>{country}</option>
                            ))}
                          </Form.Select>
                        </div>
                        <div className="d-flex flex-row mt-2 radio-btn-container ">
                          <Form.Check
                            label="Search by company"
                            type="radio"
                            name="filter"
                            className="mx-3"
                            value="search by company"
                            onChange={(e) => {
                              dispatch(onChangeRadioFilter(e.target.value));
                              dispatch(storeSearchWindowInput(""));
                            }}
                            checked={radioFilter === "search by company"}
                            disabled={
                              // selectedCountry === "Sweden" ||
                              selectedCountry === "Finland"
                            }
                            id="Company"
                          />
                          <Form.Check
                            label={labelForVatOption[selectedCountry]}
                            type="radio"
                            name="filter"
                            value="search by vat"
                            onChange={(e) => {
                              dispatch(onChangeRadioFilter(e.target.value));
                              dispatch(storeSearchWindowInput(""));
                            }}
                            checked={radioFilter === "search by vat"}
                            id="Vat"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="d-flex flex-row justify-content-center">
                      <Col xs={12} lg={6}>
                        <SearchWindowResults
                          getPlanInfo={getPlanInfo}
                          planData={planData}
                          selectedCountry={selectedCountry}
                        />
                      </Col>
                    </div>
                  </div>
                )}
              </Col>
            </Row>
          </Col>
        </Container>
      </div>
    </>
  );
}

export default SearchWindow;
